import {
  GOTO_COLLECTION_PAGE,
  SET_BIRD_NUMBER,
  PLAY_STAGE_NUMBER,
  BACKTO_MAIN_PAGE,
  UPDATE_PLAY_DATA,
  SET_BIRD_ENERGY,
  BIRD_ENERGY_UPDATE_FLAG,
  // DISPLAY_STONES,
  // SET_PLAY_STATE,
} from './types';

export const HATCH_EGG_PAGE = {
  MAIN: 'main',
  PLAY: 'play',
  COLLOECTION: 'colloection',
};

// export const HATCH_EGG_PLAY_STATE = {
//   IDLE: 1,
//   WAITING: 2,
//   DO_LOCAL: 3,
//   SERVER_RESPONSE: 4,
//   DISPLAY_CAPTURED: 5,
// };

export const backToMainPage = () => async (dispatch) => {
  return dispatch({
    type: BACKTO_MAIN_PAGE,
  });
};

export const gotoCollectionPage = () => async (dispatch) => {
  return dispatch({
    type: GOTO_COLLECTION_PAGE,
    payload: {},
  });
};

export const setBirdNumber =
  ({ birdNumber, duplicated }) =>
  async (dispatch) => {
    return dispatch({
      type: SET_BIRD_NUMBER,
      payload: { birdNumber, duplicated },
    });
  };

export const playStage =
  ({ stageNumber, playId }) =>
  async (dispatch) => {
    return dispatch({
      type: PLAY_STAGE_NUMBER,
      payload: { stageNumber, playId },
    });
  };

export const updatePlayData =
  ({ breakCount, hatchCount }) =>
  async (dispatch) => {
    return dispatch({
      type: UPDATE_PLAY_DATA,
      payload: { breakCount, hatchCount },
    });
  };

export const setBirdEnergy =
  (birdEngergy) =>
  async (dispatch) => {
    return dispatch({
      type: SET_BIRD_ENERGY,
      payload: birdEngergy,
    });
  };

export const setBirdEnergyUpdateFlag = (flag) => async (dispatch) => {
  return dispatch({
    type: BIRD_ENERGY_UPDATE_FLAG,
    payload: flag,
  });
};

// export const displayStones = (stones) => async (dispatch) => {
//   return dispatch({
//     type: DISPLAY_STONES,
//     payload: { stones },
//   });
// };

// export const setPlayState = (playState) => async (dispatch) => {
//   return dispatch({
//     type: SET_PLAY_STATE,
//     payload: { playState },
//   });
// };
